(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kalender-list"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.dulceria-kalender').forEach(function(section) {
    var chips = section.querySelectorAll('.dk-chip');
    var events = section.querySelectorAll('.dk-event');
    var count = section.querySelector('[data-count]');
    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        chips.forEach(function(c) { c.classList.remove('active'); });
        chip.classList.add('active');
        var filter = chip.getAttribute('data-filter');
        var visible = 0;
        events.forEach(function(event) {
          var tag = event.getAttribute('data-tag');
          if (filter === 'all' || tag === filter) {
            event.style.display = '';
            visible++;
          } else {
            event.style.display = 'none';
          }
        });
        if (count) count.textContent = visible;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
